import { render, staticRenderFns } from "./SysDataSourceModal.vue?vue&type=template&id=78ad43ce&scoped=true"
import script from "./SysDataSourceModal.vue?vue&type=script&lang=js"
export * from "./SysDataSourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad43ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ad43ce')) {
      api.createRecord('78ad43ce', component.options)
    } else {
      api.reload('78ad43ce', component.options)
    }
    module.hot.accept("./SysDataSourceModal.vue?vue&type=template&id=78ad43ce&scoped=true", function () {
      api.rerender('78ad43ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysDataSourceModal.vue"
export default component.exports